import {
  MessageDrawerActionButton,
  MessageDrawerActions,
  MessageDrawerBody,
  MessageDrawerRoot,
  MessageDrawerTitle,
} from "@/components/message-drawer";

interface PatientPaymentUnauthorizedDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const PatientPaymentUnauthorizedDrawer = ({
  open,
  setOpen,
}: PatientPaymentUnauthorizedDrawerProps): JSX.Element => {
  return (
    <MessageDrawerRoot setOpen={setOpen} open={open}>
      <MessageDrawerTitle>Tentativas de pagamento não autorizadas</MessageDrawerTitle>
      <MessageDrawerBody>
        <div
          className="flex flex-col gap-4 text-center"
          data-testid="patient-payment-unauthorized-drawer-main-content"
        >
          <p data-testid="patient-payment-unauthorized-drawer-main-text">
            Esse link continua <span className="font-semibold">válido.</span> Novas
            tentativas de pagamento são permitidas, mas oriente seu paciente a:
          </p>
          <ul
            className="list-inside list-disc gap gap-y-3 text-left ml-2"
            data-testid="patient-payment-unauthorized-drawer-main-table"
          >
            <li data-testid="patient-payment-unauthorized-drawer-table-first-row">
              Revisar os dados pessoais.
            </li>
            <li data-testid="patient-payment-unauthorized-drawer-table-second-row">
              Tentar novamente com{" "}
              <span className="font-semibold">outro método de pagamento.</span>
            </li>
          </ul>
          <p data-testid="patient-payment-unauthorized-drawer-bottom-text">
            Se decidir receber por outro meio, lembre-se de{" "}
            <span className="font-semibold">cancelar este link</span> para evitar
            cobranças duplicadas.
          </p>
        </div>
      </MessageDrawerBody>
      <MessageDrawerActions>
        <MessageDrawerActionButton onClick={() => setOpen(false)}>
          Voltar
        </MessageDrawerActionButton>
      </MessageDrawerActions>
    </MessageDrawerRoot>
  );
};
